<template>
    <div class="color_component">
        <ul
            class="color_component_list"
        >
            <li
                :class="[
                    'color_component_box',
                    { 'color_component_box_active': color === selectColor},
                ]"
                v-for="(color, index) in colors"
                :key="index"
                @click="handleBoxClick(color, index)"
                v-waves
            >
                <span
                    class="color_component_active_bg"
                    :style="{ background: color }"
                ></span>
                <span class="color_component_icon_ok">
                    <cl-svg-icon
                        icon-class="tu_schedule_color_ok"
                    ></cl-svg-icon>
                </span>
                <span
                    class="color_component_color"
                    :style="{ background: color, width: size + 'px', height: size + 'px' }"
                ></span>
            </li>
        </ul>
    </div>
</template>

<script>
    /**
     * ComponentName: 颜色选择组件
     * Created Date:2022/4/12
     * Author: zhanghui·chen
     * Modify: Nancy 2022/5/17
     * 组件说明：
     * 循环显示颜色列表，如果传入则展示传入的，否则显示默认的颜色，选中后提交到父组件。
     * eg:
     *  <cl-color-list v-model="color" :color-list="colors"></cl-color-list>
     */
export default {
    name: 'cl-color-list',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        // 传入的颜色值
        value: {
            type: String,
            default: ''
        },
        // 颜色列表
        colorList: {
            type: Array
        },
        // 颜色块大小 默认
        size: {
            type: String,
            default: '34'
        }
    },
    data() {
        return {
            // 默认颜色列表
            defaultColors: [
                '#FDC610',
                '#FF6536',
                '#FF5630',
                '#FF4437',
                '#E535BC',
                '#8955FF',
                '#34B5E8',
                '#558EFF',
                '#3663E1',
                '#00D190',
                '#00D1C5',
                '#00BDE4',
            ],
            selectColor: this.value || '', // 选中颜色列表
        };
    },
    computed: {
        // props 传值就是用props的色值列表，不传则使用默认defaultColors色值列表
        colors() {
            return this.colorList || this.defaultColors
        },
    },
    watch: {
        // 颜色变化的时候设置当前颜色被选中
        value() {
            this.selectColor = this.value;
        }
    },
    methods: {
        handleBoxClick(color) {
            this.selectColor = color;
            this.$emit('change', color); // 通过v-model获取
        },
    },
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
